<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Wymogi IDD'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-idd-training-details-view
      [iddTraining]="iddTraining"
      (changed)="loadIddTraining()"
    ></app-idd-training-details-view>
  </mat-tab>
  <mat-tab label="Zaświadczenia">
    <div fxLayout="column" fxLayoutGap="15px" class="idd-training-certificates" *ngIf="iddTrainingObject">
      <div fxLayout="row" fxLayoutGap="15px">
        <button [disabled]="iddTrainingObject.certificates.length === 0" (click)="downloadZip()" mat-stroked-button color="accent"><mat-icon>download</mat-icon> <span> Pobierz zaświadczenia</span></button>

        <button (click)="addCertificate()"
                [disabled]="!(userPermissions | async).idd_training.write"
                mat-stroked-button color="primary"><mat-icon>add</mat-icon> <span> Dodaj zaświadczenie</span></button>
      </div>

      <div fxLayout="row">
        <table mat-table [dataSource]="iddTrainingObject.certificates">
          <ng-container matColumnDef="meetingLeader">
            <th mat-header-cell *matHeaderCellDef> Organizator </th>
            <td mat-cell *matCellDef="let element">
              {{element.meetingLeader.name}}
            </td>
          </ng-container>

          <ng-container matColumnDef="logo">
            <th mat-header-cell *matHeaderCellDef [width]="'150px'"> Logo </th>
            <td mat-cell *matCellDef="let element" style="text-align: center">
              <img *ngIf="element.insuranceCompany?.imageLocation" src="/rest/crm/insuranceCompany/{{element.insuranceCompany?.id}}/image" alt="Zdjęcie" height="30"/>
            </td>
          </ng-container>

          <ng-container matColumnDef="insuranceCompany">
            <th mat-header-cell *matHeaderCellDef> TU </th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.insuranceCompany">
                <a class="default-link" [routerLink]="['/tu/szczegoly', element.insuranceCompany.id]">{{element.insuranceCompany.name}}</a>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="realisedHours">
            <th mat-header-cell *matHeaderCellDef> Zrealizowano </th>
            <td mat-cell *matCellDef="let element">
              Majątek: {{(floor(element.realisedAssetsMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedAssetsMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
              Życie: {{(floor(element.realisedLifeMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedLifeMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
              Ogólne: {{(floor(element.realisedGeneralMinutes / 60).toString() | number:'1.0-0') + 'h'}} {{(floor(element.realisedGeneralMinutes % 60).toString() | number:'1.0-0') + 'min'}}<br>
            </td>
          </ng-container>

          <ng-container matColumnDef="aml">
            <th mat-header-cell *matHeaderCellDef> AML </th>
            <td mat-cell *matCellDef="let element">
              {{!element.aml ? 'Nie' : 'Tak'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="realisedAt">
            <th mat-header-cell *matHeaderCellDef> Data szkolenia </th>
            <td mat-cell *matCellDef="let element">
              {{element.realisedAt | date:'y-MM-dd'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef> Data utworzenia </th>
            <td mat-cell *matCellDef="let element">
              {{element.createdAt | date:'y-MM-dd'}}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
            <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.createdBy">
                <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.username}}</a>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button (click)="certificateOverview(element)"
                      mat-icon-button color="primary"><mat-icon>visibility</mat-icon></button>
              <button (click)="downloadCertificate(element)"
                      [disabled]="!(userPermissions | async).idd_training.write"
                      mat-icon-button color="accent"><mat-icon>download</mat-icon></button>

              <button (click)="deleteCertificate(element)"
                      [disabled]="!(userPermissions | async).idd_training.delete"
                      mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Rejestracje" *ngIf="(userPermissions | async).idd_training.read">
    <ng-template matTabContent>
      <div fxLayout="column">
        <div fxLayout="row">
<!--          <button [disabled]="!(userPermissions | async).registration.create" mat-stroked-button color="primary" class="add-button"-->
<!--                  (click)="addRegistration()"><mat-icon>add</mat-icon> Dodaj rejestrację</button>-->
        </div>

        <app-all-registrations-list
          [ofwcaId]="iddTrainingObject.ofwca.uuid"  [disableFilters]="true"
          [disableBreadcrumb]="true" [embeddedView]="true"  [reloadList]="registrationsChanged"
          [excludeColumns]="['ofwca_just', 'ofwcaLastName', 'insuranceCompany_just','agreedToDeregister', 'ofwca', 'passedExam100p', 'passedExam40p',
      'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack', 'statements', 'activeKrk', 'missingExam', 'partner']"
          [statusKeys]="[REGISTRATION_STATUS_REGISTERED, REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY]"
          [iddTrainingObject]="iddTrainingObject"
        ></app-all-registrations-list>

      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
